export function addDays(targetDate: string | Date, days: number): Date {
  const date = new Date(targetDate);
  date.setDate(date.getDate() + days);
  return date;
}

export function formatDate(date: Date, userLocale: string = navigator.language): string {
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

  return new Intl.DateTimeFormat(userLocale, options).format(date);
}
